module.exports = __webpack_public_path__ + "clients/assets/v1/img/cg_code.svg";